$(function () {
	var dropDownTrigger = $('.cd-dropdown-trigger');
	var menuBarLinkFirst = $('.menuSubCategoriesMain').find('li').filter(':visible').first().find('a').first();
	var menuBarLinkLast = $('.menuSubCategoriesMain').find('li').filter(':visible').last().find('a').first();
	var dropDownFirstLink =  $('#topOfMenu').find('li').filter(':visible').first().find('a').first();
	var dropDownLastLink = $('#seeMoreMenuLink');

	//ACCESSIBILITY KEYBOARD BITS -->
	// MAIN MENU TRIGGER
	$('.cd-dropdown-trigger').keydown(function(e){
		// Listen for the up, down, left and right arrow keys, otherwise, end here
		if ([32, 37, 38, 39,40].indexOf(e.which) == -1) {
			return;
		}

		switch(e.which) {
			case 37: // left arrow
				e.preventDefault();
				e.stopPropagation();
				// Focus on last link in menu bar
				menuBarLinkLast.focus();
				$('.cd-dropdown').removeClass('dropdown-is-active');
				dropDownTrigger.removeClass('dropdown-is-active');
				break;
			case 39: // right arrow
				e.preventDefault();
				e.stopPropagation();
				// Focus on first link in menu bar
				menuBarLinkFirst.focus();
				$('.cd-dropdown').removeClass('dropdown-is-active');
				dropDownTrigger.removeClass('dropdown-is-active');
				break;
			case 32: // space bar
			case 38: // up arrow
			case 40: // down arrow
				e.preventDefault();
				e.stopPropagation();
				$('.cd-dropdown').addClass('dropdown-is-active');
				dropDownTrigger.addClass('dropdown-is-active');				
				setTimeout(function() { dropDownFirstLink.focus(); }, 300);
		}
	});
    
	// MENU BAR LIST ITEMS
	$('.menuSubCategories a').keydown(function(e){
		// Listen for the left and right arrow keys, otherwise, end here
		if ([37,39].indexOf(e.which) == -1) {
			return;
		}
	
		switch(e.which) {
			case 37: // left arrow
				e.preventDefault();
				e.stopPropagation();
				// If first link in menu bar, focus on main drop down trigger
				if((menuBarLinkFirst).is(':focus')){
					dropDownTrigger.focus();
				// Else focus on previous link in menu bar
				} else {
					$(this).parent('li').prevAll('li').filter(':visible').first().find('a').focus();
				}
				break;
			case 39: // right arrow
				e.preventDefault();
				e.stopPropagation();
				// If last link in menu bar, focus on main drop down trigger
				if((menuBarLinkLast).is(':focus')){
					dropDownTrigger.focus();
				// Else focus on next link in menu bar
				} else {
					$(this).parent('li').nextAll('li').filter(':visible').first().find('a').focus();
				}
		}
	});

	// MAIN DROP DOWN
	$('#topOfMenu a').keydown(function(e){
		// Listen for the up, down, left and right arrow keys, otherwise, end here
		if ([38, 39,40].indexOf(e.which) == -1) {
			return;
		}

		switch(e.which) {
			case 38: // up arrow
				e.preventDefault();
				e.stopPropagation();
				// If first link in drop down menu, focus on main drop down trigger
				if((dropDownFirstLink).is(':focus')){
					dropDownTrigger.focus();
				// Else focus on previous link in drop down
				} else {
					$(this).parent('li').prevAll('li').filter(':visible').first().find('a').first().focus();
				}
				break;
			case 39: // right arrow
				e.preventDefault();
				e.stopPropagation();
				// Show flyout menu and focus on first link inside of it
				$(this).siblings('.cd-secondary-dropdown').first().addClass('is-active').attr('aria-hidden', 'false');
				$(this).addClass('is-active');
				$(this).siblings('.cd-secondary-dropdown').find('li').filter(':visible').first().find('a').first().focus();
				break;
			case 40: // down arrow
				e.preventDefault();
				e.stopPropagation();
				// If last link in drop down, focus on main drop down trigger
				if((dropDownLastLink).is(':focus')){
					dropDownTrigger.focus();
				// Else focus on next link in drop down
				} else {
					$(this).parent('li').nextAll('li').filter(':visible').first().find('a').first().focus();
				}
		}
	});
    
	// FLYOUT MENU BLUE HEADER LINKS
	$('.subCatHead a').keydown(function(e){
		// Listen for the up, down, left and right arrow keys, otherwise, end here
		if ([37, 38, 39,40].indexOf(e.which) == -1) {
			return;
		}
		var firstCatHead = $(this).parent().parent().find('.subCatHead').filter(':visible').first().find('a').first();
		var lastCatHead = $(this).parent().parent().find('.subCatHead').filter(':visible').last().find('a').first();
        
		switch(e.which) {
			case 37: // left arrow
				e.preventDefault();
				e.stopPropagation();
				// If first submenu head is focused, close flyout and focus on category in dropdown
				if(firstCatHead.is(':focus')){
					$(this).parent('li').parent('ul').removeClass('is-active').attr('aria-hidden', 'true');
					$(this).parent('li').parent('ul').prev('a').removeClass('is-active').focus();
				// Else go to previous sub category last link
				} else {
					$(this).parent('li').prev('.subCatHead').find('a').first().focus();
				}
				break;
			case 38: // up arrow
				e.preventDefault();
				e.stopPropagation();
				// If first submenu head is focused, close flyout and focus on category in dropdown
				if(firstCatHead.is(':focus')){
					$(this).parent('li').parent('ul').removeClass('is-active').attr('aria-hidden', 'true');
					$(this).parent('li').parent('ul').prev('a').removeClass('is-active').focus();
				// Else go to previous sub category last link
				} else {
					$(this).parent('li').prev('li').find('ul').find('li').filter(':visible').last().find('a').focus();
				}
				break;
			case 39: // right arrow
				e.preventDefault();
				e.stopPropagation();
				// If last submenu head link, go to first product advert
				if(lastCatHead.is(':focus')){
					$(this).parent().parent('.cd-secondary-dropdown').find('.menuAdvert:visible').first().find('a').first().focus();
				// Else go to next submenu head link
				}else{
					$(this).parent('li').nextAll('li').first().find('a').first().focus();
				}
				break;
			case 40: // down arrow	
				e.preventDefault();
				e.stopPropagation();
				// Focus on first subcategory link under submenu head
				$(this).siblings('ul').find('li').filter(':visible').first().find('a').focus();
		}
	});
    
	// FLYOUT MENU CATEGORY SUBLINKS
	$('.subCategories li a').keydown(function(e){
		// Listen for the up, down, left and right arrow keys, otherwise, end here
		if ([37, 38, 39,40].indexOf(e.which) == -1) {
			return;
		}
		var firstSubCat = $(this).parent().parent().parent().parent().find('.subCatHead').filter(':visible').first().find('a');
		
		switch(e.which) {
			case 37: // left arrow
				e.preventDefault();
				e.stopPropagation();     
				// If the first category sublink, close flyout and focus on category link in dropdown
				firstSubCat.each(function() {
					if (firstSubCat.is(':focus')){
						$(this).parent('li').parent('ul').removeClass('is-active').attr('aria-hidden', 'true');
						$(this).parent('li').parent('ul').prev('a').removeClass('is-active').focus();
					}
				});
				// Otherwise focus on the previous submenu head link
				$(this).parent().parent().parent().prev('.subCatHead').find('a').first().focus();
				break;
			case 38: // up arrow
				e.preventDefault();
				e.stopPropagation();
				// If the first category sublink, focus on submenu head link
				$(this).first().each(function() {
					if ($(this).is(':focus')) {
						$(this).parent('li').parent('ul').prev('a').focus();
					}
				});
				break;
			case 39: // right arrow
				e.preventDefault();
				e.stopPropagation();
				// Focus on next subcategory's main link
				$(this).parent().parent().parent().next().find('a').first().focus();
				break;
			case 40: // down arrow	
				e.preventDefault();
				e.stopPropagation();
				// If the last category sublink, focus on next subcategory's main link
				$(this).last().each(function() {
					if ($(this).is(':focus')) {
						$(this).parent().parent().parent().next().find('a').first().focus();
					}
				});
		}
	});

	// POPULAR PRODUCTS
	$('.menuAdvert a').keydown(function(e){
		// Listen for the up, down, left and right arrow keys, otherwise, end here
		if ([37, 38, 39,40].indexOf(e.which) == -1) {
			return;
		}
		var lastProdAdvert = $(this).parent().parent('.productAdverts').find('.menuAdvert').filter(':visible').last().find('a');
		var firstProdAdvert = $(this).parent().parent('.productAdverts').find('.menuAdvert').filter(':visible').first().find('a');
	 	
		switch(e.which) {
			case 37: // left arrow
				e.preventDefault();
				e.stopPropagation();
				// If first product link, go to previous subcat header
				if(firstProdAdvert.is(':focus')){
					$(this).parent().parent().parent().prev('.subCatHead').filter(':visible').find('a').first().focus();
				}else {
				// Else go to previous product link
					$(this).parent().prev('li').find('a').first().focus();
				}
				break;
			case 38: // up arrow
				e.preventDefault();
				e.stopPropagation();
				// Go to previous subcat last link
				$(this).parent().parent().parent().prev('.subCatHead').filter(':visible').find('li').filter(':visible').last().find('a').focus();
				break;
			case 39: // right arrow
				e.preventDefault();
				e.stopPropagation();
				// If last product link, go to first subcat header in flyout
				if(lastProdAdvert.is(':focus')){
					$(this).parent().parent().parent().prevAll().filter(':visible').last('.subCatHead').filter(':visible').find('a').first().focus();
				// Else go to the next product link
				}else {
					$(this).parent().next('li').find('a').first().focus();
				}   
	         		break;
			case 40: // down arrow
				e.preventDefault();
				e.stopPropagation();
				// Close flyout and focus on main category link
				$(this).parent('li').parent('ul').parent().parent().removeClass('is-active').attr('aria-hidden', 'true');
				$(this).parent('li').parent('ul').parent().parent().prev('a').removeClass('is-active').focus();
		}
	});
	
	$(document).on("keydown", function(e){
		if(e.keyCode == 27 && $('.cd-dropdown').hasClass('dropdown-is-active')){ //esc
			$('.cd-dropdown').removeClass('dropdown-is-active');
			dropDownTrigger.removeClass('dropdown-is-active').focus();
		}
	});
});